export default __webpack_public_path__ + "static/media/GCPLogo.04161fd4.png";